import React from 'react';
import { Link } from 'react-router-dom';

import { SiteConfigManager } from '@atlas/core';
import { COMPONENT_TYPES } from '@atlas/routing';
import { Icon, Label } from '@atlas/ui';

import { defaultRoutes } from 'components/MainRouter/constants';
import SeoPageText from 'components/SeoPage/SeoPageText';
import { useCompetitionsContext } from 'components/Tournament/context/context';
import TournamentCard from 'components/Tournament/TournamentCard';

const { PROMOTION_TOURNAMENTS } = COMPONENT_TYPES;

const Competition = () => {
  const { menu } = defaultRoutes;
  const competitionPath = SiteConfigManager.getComponentPath(PROMOTION_TOURNAMENTS);

  const { competitions } = useCompetitionsContext();

  return (
    <div className="layout-to-scroll">
      <div className="promotion_page">
        <Link className="back-to-container" to={menu}>
          <Icon className="icon-back" name="back" />
          <h1>
            <Label className="title-text" message="Tournaments" />
          </h1>
        </Link>
        <div className="promotion">
          {competitions.map((competition, index) => (
            <Link
              aria-label={competition.description?.name}
              className="tournaments-promotions-card"
              key={competition.id}
              to={`${competitionPath}/${competition.id}`}
            >
              <div className="tournaments-promotions-card__wrapper">
                <TournamentCard competition={competition} index={index} />
              </div>
            </Link>
          ))}
        </div>
      </div>
      <SeoPageText />
    </div>
  );
};

export default Competition;
